import { useState } from "react";
import { Slider } from "@/components/ui/slider";

const FilterMenu = ({
  // colors,
  // sizes,
  // buns,
  price,
  filters,
  animes,
  brands,
  handleChange,
  searchFilter,
  setSearchFilter,
}: {
  // colors: any;
  // sizes: any;
  // buns: any;
  price: any;
  filters: any;
  animes: any;
  brands: any;
  handleChange: any;
  searchFilter: any;
  setSearchFilter: any;
}) => {
  const [openFilters, setOpenFilters] = useState<number[]>([]);

  // const [searchValue, setSearchValue] = useState({
  //   minPrice: 0,
  //   maxPrice: 20000000,
  // });

  const toggleFilter = (index: number) => {
    if (openFilters.includes(index)) {
      setOpenFilters(openFilters.filter((i) => i !== index));
    } else {
      setOpenFilters([...openFilters, index]);
    }
  };
  const { type, brand, anime } = searchFilter;
  // const [selectedSize, setSelectedSize] = useState("Large");
  // const [selectedColor, setSelectedColor] = useState("Blue");

  return (
    <>
      {/* <div className="search mb-2">
                  <input type="text" name="search" />
                </div> */}

      <div className="w-full md:w-full p-4 bg-white rounded-lg shadow">
        <div className="flex justify-between items-center mb-4 border-b pb-3">
          <h3 className=" font-bold">Филтри</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-1 1h3a1 1 0 01-1-1V4z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M7 11h10M7 16h10"
            />
          </svg>
        </div>

        <ul className="space-y-4">
          {filters.map((filter: any, index: number) => (
            <li key={index} className={`border-gray-300`}>
              <div
                className="flex justify-between items-center w-full cursor-pointer"
                // onClick={() => toggleFilter(filter?.index)}
                onClick={() => handleChange("type", filter.title, "")}
              >
                <span
                  className={`${
                    type == filter.title ? "text-[#ffc633]" : " text-gray-700 "
                  }  `}
                >
                  {filter.title}
                </span>
                {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${openFilters.includes(index) ? "rotate-90" : ""
                  }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg> */}
              </div>
              {/* {filter.subcategories && (
              <ul
                className={`pl-1 mt-2 space-y-2 ${openFilters.includes(filter?.index) ? "" : "hidden"
                  }`}
              >
                {filter.subcategories.map((subcategory: any, subIndex: any) => (
                  <li key={subIndex} className="text-sm py-2 text-gray-500">
                    {subcategory}
                  </li>
                ))}
              </ul>
            )} */}

              {filter.type === "availability" &&
                openFilters.includes(index) && (
                  <div className="pl-1 mt-2 space-y-2">
                    {filter.options.map((option: any, optIndex: any) => (
                      <div key={optIndex} className="text-sm text-gray-500">
                        <input
                          type="checkbox"
                          id={`option-${optIndex}`}
                          className="mr-2"
                        />
                        <label htmlFor={`option-${optIndex}`}>{option}</label>
                      </div>
                    ))}
                  </div>
                )}
            </li>
          ))}
        </ul>

        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold"></h3>
        </div>

        <ul className="space-y-4">
          {price?.map((filter: any, index: any) => (
            <li key={index} className="border-gray-300 border-y py-2">
              <div
                className="flex justify-between items-center w-full cursor-pointer"
                onClick={() => toggleFilter(filter?.index)}
              >
                <h3 className="text-gray-700 font-bold">{filter.title}</h3>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
                    openFilters.includes(filter?.index) ? "rotate-90" : ""
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
              {filter.subcategories && (
                <ul
                  className={`pl-1 mt-2 space-y-2 ${
                    openFilters.includes(filter?.index) ? "" : "hidden"
                  }`}
                >
                  {filter.subcategories.map(
                    (subcategory: any, subIndex: any) => (
                      <li key={subIndex} className="text-sm py-2 text-gray-500">
                        {subcategory}
                      </li>
                    )
                  )}
                </ul>
              )}
              {filter.type === "price" &&
                openFilters.includes(filter?.index) && (
                  <div className="my-8">
                    <Slider
                      showNewPoints={true}
                      onValueChange={(value: number[]) =>
                        setSearchFilter((prev: any) => ({
                          ...prev,
                          minPrice: value[0],
                          maxPrice: value[1],
                        }))
                      }
                      value={[
                        searchFilter.minPrice ?? 0, // Default to 0 if minPrice is null or undefined
                        searchFilter.maxPrice ?? 1000, // Default to 20000000 if maxPrice is null or undefined
                      ]}
                      min={0}
                      max={1000}
                      step={1}
                    />
                  </div>
                )}
            </li>
          ))}
        </ul>

        {/* <div className="flex justify-between  items-center mb-4"></div> */}
        {/* 
      <ul className="space-y-4">
        {buns.map((filter: any, index: any) => (
          <li key={index} className="border-gray-300 ">
            <div
              className="flex justify-between items-center w-full cursor-pointer"
              onClick={() => toggleFilter(filter.index)}
            >
              <h3 className="text-gray-700 font-bold">{filter.title}</h3>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${openFilters.includes(filter.index) ? "rotate-90" : ""
                  }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>

            {filter.subcategories && (
              <ul
                className={`pl-1 ${openFilters.includes(filter.index) ? "" : "hidden"
                  }`}
              >
                {filter.subcategories.map((subcategory: any, subIndex: any) => (
                  <li key={subIndex}>
                    <div
                      className="flex justify-between items-center w-full cursor-pointer"
                      onClick={() => toggleFilter(subcategory.index)}
                    >
                      <span className="text-sm py-2 text-gray-500">
                        {subcategory.title}
                      </span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${openFilters.includes(subcategory.index)
                          ? "rotate-90"
                          : ""
                          }`}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </div>

                    {subcategory.subcategories && (
                      <ul
                        className={`pl-1 mt-2 space-y-2 ${openFilters.includes(subcategory.index)
                          ? ""
                          : "hidden"
                          }`}
                      >
                        {subcategory.subcategories.map(
                          (nestedSubcategory: any, nestedIndex: any) => (
                            <li
                              key={nestedIndex}
                              className="text-sm py-2 text-gray-400"
                            >
                              {nestedSubcategory.title}
                            </li>
                          )
                        )}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul> */}

        {/* <div className="flex justify-between  items-center mb-4"></div> */}

        <div
          className="flex justify-between items-center w-full cursor-pointer space-y-4 border-gray-300  border-b py-2"
          onClick={() => toggleFilter(13)}
        >
          <h3 className="text-gray-700 font-bold">Брандове</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
              openFilters.includes(13) ? "rotate-90" : ""
            }`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
        <ul className={`pl-1 ${openFilters.includes(13) ? "" : "hidden"}`}>
          {brands.map((filter: any, index: any) => (
            <li key={index}>
              <div
                className="flex justify-between items-center w-full cursor-pointer"
                onClick={() => handleChange("brand", filter.title, "")}
              >
                <span
                  className={`${
                    brand == filter.title ? "text-[#ffc633]" : " text-gray-500 "
                  } text-sm py-2  `}
                >
                  {filter.title}
                </span>
                {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${openFilters.includes(brandName.index)
                  ? "rotate-90"
                  : ""
                  }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg> */}
              </div>

              {/* {brandName.subcategories && (
                      <ul
                        className={`pl-1 mt-2 space-y-2 ${openFilters.includes(brandName.index) ? "" : "hidden"
                          }`}
                      >
                        {brandName.subcategories.map(
                          (nestedSubcategory: any, nestedIndex: any) => (
                            <li
                              key={nestedIndex}
                              className="text-sm py-2 text-gray-400"
                            >
                              {nestedSubcategory.title}
                            </li>
                          )
                        )}
                      </ul>
                    )} */}
            </li>
          ))}
        </ul>

        <div
          className="flex justify-between items-center w-full cursor-pointer   py-2"
          onClick={() => toggleFilter(19)}
        >
          <h3 className="text-gray-700 font-bold">Anime</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
              openFilters.includes(19) ? "rotate-90" : ""
            }`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
        <ul className={`pl-1 ${openFilters.includes(19) ? "" : "hidden"}`}>
          {animes.map((filter: any, index: any) => (
            <li key={index}>
              <div
                className="flex justify-between items-center w-full cursor-pointer"
                onClick={() => handleChange("anime", filter.title, "")}
              >
                <span
                  className={`${
                    anime == filter.title ? "text-[#ffc633]" : " text-gray-500 "
                  } text-sm py-2  `}
                >
                  {filter.title}
                </span>
                {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${openFilters.includes(brandName.index)
                  ? "rotate-90"
                  : ""
                  }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg> */}
              </div>

              {/* {brandName.subcategories && (
                      <ul
                        className={`pl-1 mt-2 space-y-2 ${openFilters.includes(brandName.index) ? "" : "hidden"
                          }`}
                      >
                        {brandName.subcategories.map(
                          (nestedSubcategory: any, nestedIndex: any) => (
                            <li
                              key={nestedIndex}
                              className="text-sm py-2 text-gray-400"
                            >
                              {nestedSubcategory.title}
                            </li>
                            )
                        )}
                      </ul>
                    )} */}
            </li>
          ))}
        </ul>

        <div className="flex justify-between  items-center mb-4"></div>

        {/* <ul className="space-y-4 border-t">
        {sizes.map((filter: any, index: any) => (
          <li key={index} className="border-gray-300 mt-2 ">
            <div
              className="flex justify-between items-center w-full cursor-pointer"
              onClick={() => toggleFilter(filter.index)}
            >
              <h3 className="text-gray-700 font-bold">{filter.title}</h3>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${openFilters.includes(filter.index) ? "rotate-90" : ""
                  }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>

            {filter.subSizes && (
              <ul
                className={`pl-1 flex gap-2 flex-wrap ${openFilters.includes(filter.index) ? "" : "hidden"
                  }`}
              >
                {filter.subSizes.map((subSizes: any, subIndex: any) => (
                  <div
                    onClick={() => handleChange("size", subSizes?.title)}
                    key={index} // Using index as the key
                    className={`p-2  mt-2 rounded-full  border cursor-pointer border-gray-300 text-gray-600 text-[12px] 
                      ${searchFilter?.size === subSizes.title
                        ? "bg-black text-white"
                        : "bg-gray-100"
                      }`}
                  >
                    {subSizes.title}{" "}
                  </div>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul> */}

        <div className="flex justify-between  items-center mb-4"></div>

        {/* <ul className="space-y-4 border-t">
        {colors.map((filter: any, index: any) => (
          <li key={index} className="border-gray-300 mt-2 ">
            <div
              className="flex justify-between items-center w-full cursor-pointer"
              onClick={() => toggleFilter(filter.index)}
            >
              <h3 className="text-gray-700 font-bold">{filter.title}</h3>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${openFilters.includes(filter.index) ? "rotate-90" : ""
                  }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>

            {filter.subColors && (
              <ul
                className={`pl-1  mt-2 flex gap-2 flex-wrap ${openFilters.includes(filter.index) ? "" : "hidden"
                  }`}
              >
                {filter.subColors.map((subcolor: any, subIndex: any) => (
                  <div
                    key={subcolor.name}
                    onClick={() => handleChange("color", subcolor.name)}
                    className={`w-10 h-10  rounded-full focus:outline-none  cursor-pointer
             ${subcolor.color} flex justify-center items-center
             ${subcolor === subcolor.name ? "ring-4 ring-blue-500" : ""}`}
                  >
                    {searchFilter?.color === subcolor.name && (
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                    )}
                  </div>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul> */}
      </div>
    </>
  );
};

// Example filter data
// const filters = [
//   {
//     index: "01",
//     title: "Статуетки",
//     type: "category",
//     subcategories: ["Subcategory 1", "Subcategory 2"],
//   },
//   {
//     index: "02",

//     title: "Qposket",
//     type: "category",
//     subcategories: ["Subcategory 1", "Subcategory 2"],
//   },
//   {
//     index: "03",

//     title: "Qposket - petit",
//     type: "category",
//     subcategories: ["Subcategory 1", "Subcategory 2"],
//   },
//   {
//     index: "04",

//     title: "Gundam",
//     type: "category",
//     subcategories: ["Subcategory 1", "Subcategory 2"],
//   },
//   {
//     index: "05",

//     title: "Плюшки",
//     type: "category",
//     subcategories: ["Subcategory 1", "Subcategory 2"],
//   },
//   {
//     index: "06",

//     title: "Падове",
//     type: "category",
//     subcategories: ["Subcategory 1", "Subcategory 2"],
//   },
//   {
//     index: "07",

//     title: "Ключодържатели",
//     type: "category",
//     subcategories: ["Subcategory 1", "Subcategory 2"],
//   },
//   {
//     index: "08",

//     title: "Шапки",
//     type: "category",
//     subcategories: ["Subcategory 1", "Subcategory 2"],
//   },
// ];

// const price = [
//   {
//     index: "09",

//     title: "Цена",
//     type: "price",
//     subcategories: null, // No subcategories for price
//   },
// ];
// const buns = [
//   {
//     index: "10",

//     title: "Плюшки",
//     type: "Плюшки",
//     subcategories: [
//       {
//         title: "Наличен",
//         index: "11",
//         subcategories: [{ title: "one" }, { title: "two" }],
//       },
//       {
//         title: "Не е наличен",
//         index: "12",
//         subcategories: [{ title: "one" }, { title: "two" }],
//       },
//     ],
//   },
// ];

// const brands = [
//   {
//     index: "13",

//     title: "Марка",
//     type: "Марка",
//     subcategories: [
//       {
//         title: "Banpresto",
//         index: "14",
//         subcategories: [{ title: "one" }, { title: "two" }],
//       },
//       {
//         title: "SEGA",
//         index: "15",
//         subcategories: [{ title: "one" }, { title: "two" }],
//       },
//       {
//         title: "Funko POP",
//         index: "16",
//         subcategories: [{ title: "one" }, { title: "two" }],
//       },
//       {
//         title: "Furyu",
//         index: "17",
//         subcategories: [{ title: "one" }, { title: "two" }],
//       },
//       {
//         title: "Good Smile Company",
//         index: "18",
//         subcategories: [{ title: "one" }, { title: "two" }],
//       },
//     ],
//   },
// ];

// const sizes = [
//   {
//     index: "14",

//     title: "Sizes",
//     type: "Sizes",
//     subSizes: [
//       { index: "001", title: "XX-Small" },
//       { index: "002", title: "X-Small" },
//       { index: "003", title: "Small" },
//       { index: "004", title: "Medium" },
//       { index: "005", title: "Large" },
//       { index: "006", title: "X-Large" },
//       { index: "007", title: "XX-Large" },
//       { index: "008", title: "3X-Large" },
//       { index: "009", title: "4X-Large" },
//     ],
//   },
// ];

// const colors = [
//   {
//     index: "15",

//     title: "Colors",
//     type: "Colors",
//     subColors: [
//       { color: "bg-green-500", name: "Green" },
//       { color: "bg-red-500", name: "Red" },
//       { color: "bg-yellow-500", name: "Yellow" },
//       { color: "bg-orange-500", name: "Orange" },
//       { color: "bg-cyan-500", name: "Cyan" },
//       { color: "bg-blue-500", name: "Blue" },
//       { color: "bg-purple-500", name: "Purple" },
//       { color: "bg-pink-500", name: "Pink" },
//       { color: "bg-white border", name: "White" }, // Adding a border for visibility
//       { color: "bg-black", name: "Black" },
//     ],
//   },
// ];

export default FilterMenu;
